// extracted by mini-css-extract-plugin
module.exports = {"details":"Details_details__ISb1k","header":"Details_header__zk2Lg","content":"Details_content__2cYUW"};